import { render } from "./Web.vue?vue&type=template&id=11b8b10a&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"

import "./Web.vue?vue&type=style&index=0&id=11b8b10a&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b8b10a"]])

export default __exports__